const imp = () => import(/* webpackChunkName: "ui_commont_icon"*/  "../sprite/loadSprite_client");
const loadMap_client: { [key: string]: () => Promise<any> } = {
  "Icon-Browser-open-o": imp,
  "Icon-Copy-link-o": imp,
  "Icon-Maximize-o": imp,
  "Icon-forward-o": imp,
  "Icon-back-off-o": imp,
  "Icon-minimize-o": imp,
  "Icon-recovery-o": imp,
}

export default loadMap_client;